import NextSteps from '../components/NextSteps';
import type { WidgetProps } from './types';

// The questions the record cannot answer yet, across the workspace.
export default function NextStepsWidget({ config }: WidgetProps<{ limit?: number }>) {
  return <NextSteps limit={config.limit} />;
}
